var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import * as Icon from 'react-feather';
import { location } from '../common/siteData';
var StyledSocialList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  margin: 1rem 0;\n  padding: 0;\n"], ["\n  list-style: none;\n  margin: 1rem 0;\n  padding: 0;\n"])));
var Item = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  margin-right: 1ch;\n  vertical-align: middle;\n\n  svg {\n    vertical-align: middle;\n  }\n\n  a {\n    color: #e14;\n  }\n"], ["\n  display: inline-block;\n  margin-right: 1ch;\n  vertical-align: middle;\n\n  svg {\n    vertical-align: middle;\n  }\n\n  a {\n    color: #e14;\n  }\n"])));
var SocialList = function (_a) {
    var data = _a.data;
    var items = data.map(function (item, index) {
        var SocialIcon = item.icon;
        return (React.createElement(Item, { key: index },
            React.createElement("a", { href: item.url },
                React.createElement(SocialIcon, null))));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledSocialList, null,
            items,
            React.createElement(Item, null,
                React.createElement(Icon.MapPin, null),
                " ",
                location))));
};
export default SocialList;
var templateObject_1, templateObject_2;
